import { Link } from "react-router-dom";
import { categories, mangaList } from "@/mocks/manga";

const icons: Record<string, string> = {
  love: "ri-heart-3-line",
  campus: "ri-graduation-cap-line",
  daily: "ri-cup-line",
  healing: "ri-heart-pulse-line",
  comedy: "ri-emotion-happy-line",
  sports: "ri-football-line",
};

export default function CategoryGrid() {
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-end justify-between">
        <div>
          <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">漫画分类</h2>
          <p className="mt-2 text-sm text-foreground-600">按题材发现你喜欢的漫画</p>
        </div>
        <Link to="/category/love" className="hidden items-center gap-1 text-sm text-primary-600 hover:text-primary-700 sm:inline-flex">
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
        {categories.map((c, i) => {
          const count = mangaList.filter((m) => m.category === c.slug).length;
          const tones = [
            "bg-primary-100 text-primary-700",
            "bg-accent-100 text-accent-700",
            "bg-secondary-100 text-secondary-900",
            "bg-primary-50 text-primary-600",
            "bg-accent-50 text-accent-700",
            "bg-secondary-50 text-secondary-900",
          ];
          return (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              className="group flex flex-col items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-5 text-center transition-colors hover:border-primary-200"
            >
              <span className={`flex h-12 w-12 items-center justify-center rounded-full ${tones[i % tones.length]}`}>
                <i className={`${icons[c.slug] ?? "ri-book-line"} text-xl`}></i>
              </span>
              <span className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600">{c.name}漫画</span>
              <span className="text-xs text-foreground-500">{count} 部连载</span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}